import styled from 'styled-components';

export const Card = styled.div`
  .poster,
  .line {
    background: linear-gradient(
      100deg,
      var(--surface-2) 30%,
      var(--surface) 50%,
      var(--surface-2) 70%
    );
    background-size: 300% 100%;
    animation: shimmer 1.4s linear infinite;
  }

  .poster {
    aspect-ratio: 2 / 3;
    border-radius: var(--radius);
  }

  .line {
    height: 14px;
    margin-top: 14px;
    border-radius: 6px;
    width: 85%;
  }

  .line.short {
    width: 40%;
    margin-top: 8px;
  }

  @keyframes shimmer {
    from {
      background-position: 100% 0;
    }
    to {
      background-position: 0 0;
    }
  }
`;
